module.exports = __webpack_public_path__ + "left2.png?15d393948998811ff1cc553c870fb2a8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left2.png
// module id = 605
// module chunks = 0